export * from '@angular/platform-browser/testing';

console.log(`platform-browser-dynamic/testing is deprecated, use platform-browser/testing instead`);


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
